import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getAppointmentStatus } from 'app/selectors/valuation'

import { MaterialIcon } from 'controls'
import Button from 'controls/Button'
import Modal from 'controls/Modal'
import ActionModal from 'components/Calendar/ActionModal'
import CustomEventModal from 'components/Modals/CustomEventModal'
import { CustomEventActionCreators } from 'app/reducers/CustomEventRedux'

import store from 'services/store'

import { actions } from './styles'

class Actions extends PureComponent {
  static propTypes = {
    event: PropTypes.object.isRequired,
    saveEvent: PropTypes.func.isRequired,
    canSaveEvent: PropTypes.bool.isRequired,
    cancelEvent: PropTypes.func.isRequired,
    confirmEvent: PropTypes.func.isRequired,
    deleteEvent: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false
    }
  }

  closeModal = () => this.setState({ isModalOpen: false })

  openModal = () => this.setState({ isModalOpen: true })

  openUpdateEventModal = () => {
    this.props.actions.setEvent(this.props.event)
    this.props.actions.setEventType('CUSTOM_EVENT')
    this.props.actions.setAddingOrEditingCustomEvent(true)
  }

  saveButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={this.props.saveEvent}
        color="primary"
        disabled={!this.props.canSaveEvent}
        size="small"
      >
        Guardar
      </Button>
    ) : null

  cancelButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={this.openModal}
        color="primary"
        size="small"
        key=""
      >
        Cancelar
      </Button>
    ) : null

  editButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={() => console.log('editar')}
        color="secondary"
        size="small"
        key="editar"
        outline
      >
        Editar
      </Button>
    ) : null

  confirmButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={this.props.confirmEvent}
        color="primary"
        size="small"
        key="confirmar"
      >
        Confirmar
      </Button>
    ) : null

  editCustomEventButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={this.openUpdateEventModal}
        color="primary"
        size="small"
        key="editEvent"
      >
        Editar
      </Button>
    ) : null

  deleteButton = condition =>
    condition ? (
      <Button
        className="action-btn"
        onClick={this.openModal}
        color="primary"
        size="small"
        key="borrar"
      >
        Borrar
      </Button>
    ) : null

  render() {
    const { event } = this.props
    const { isModalOpen } = this.state

    return (
      <div className="container">
        <Modal isOpen={isModalOpen} onClose={this.closeModal}>
          <ActionModal
            appointmentType={event.type.toUpperCase()}
            cancelEvent={this.props.cancelEvent}
            deleteEvent={this.props.deleteEvent}
            reasonType="CANCELLED"
            closeModal={this.closeModal}
          />
        </Modal>
        {this.saveButton(
          new Date().valueOf() >= event.start &&
            (event.status === 'PENDING' || event.status === 'CONFIRMED') &&
            event.type !== 'CUSTOM_EVENT'
        )}
        {this.cancelButton(
          new Date().valueOf() < event.start && event.type !== 'CUSTOM_EVENT'
        )}
        {this.editButton(false)}
        {this.confirmButton(
          event.status === 'PENDING' && new Date().valueOf() <= event.start
        )}
        {this.editCustomEventButton(event.type == 'CUSTOM_EVENT')}
        {this.deleteButton(event.type == 'CUSTOM_EVENT')}
        <style jsx>{actions}</style>
      </div>
    )
  }
}

const mapStateToProps = state => {}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setAddingOrEditingCustomEvent:
        CustomEventActionCreators.setAddingOrEditingCustomEvent,
      setEvent: CustomEventActionCreators.setEvent,
      setEventType: CustomEventActionCreators.setEventType
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(Actions)
